import { useEffect, useState } from 'react';
import axios from 'axios';

// Backed by GET /api/public/listPartners (api/controller/public.js) and
// managed via the admin-panel Partners page - admins set each partner's
// `order` there to control display sequence.
//
// No placeholder fallback: an empty/failed response just leaves
// `partners` as []. Callers should hide their partner section entirely
// when it's empty rather than show anything in its place.
const PARTNERS_ENDPOINT = `${process.env.REACT_APP_API_URL}/api/public/listPartners`;

const sortByOrder = (list) =>
    [...list].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

const usePartners = () => {
    const [partners, setPartners] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        const fetchPartners = async () => {
            try {
                const response = await axios.get(PARTNERS_ENDPOINT);
                const fetched = response?.data?.partners;
                if (Array.isArray(fetched)) {
                    setPartners(sortByOrder(fetched));
                }
            } catch (error) {
                // Leave partners as [] - the section hides itself.
            } finally {
                setIsLoaded(true);
            }
        };
        fetchPartners();
    }, []);

    return { partners, isLoaded };
};

export default usePartners;
